import { render, staticRenderFns } from "./OQCMenuPage.vue?vue&type=template&id=5e269cd6&"
import script from "./OQCMenuPage.vue?vue&type=script&lang=js&"
export * from "./OQCMenuPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports